import React from 'react';
import Home from './home';
import Prepare from './prepare';
import Learn from './learn';
import Reflect from './reflect';
import Challenge from './challenge';
import Certificate from './certificate';
import backgroundImage from '../assets/images/background.svg';
import menuLogo from '../assets/images/logo-future-well-kids@2x.png';
import progressBarImage from '../assets/images/global-ribbon.svg';
import Footer from './footer';

export default {
  pages: [Home, Prepare, Learn, Reflect, Challenge, Certificate],
  metaData: {
    Footer,
    backgroundImages: {
      backgroundImage
    },
    menu: {
      logo: <img src={menuLogo} alt="menu logo" />,
      title: 'Nutritious Eating'
      // subTitle: 'Unit 1 | Topic 2'
    },
    progressBarImage
  }
};



// WEBPACK FOOTER //
// ./src/data/index.js